
import axios from 'axios'
import Choices from '@/components/Subjects/Choices'
import Judgement from '@/components/Subjects/Judgement'
import ShortAnswer from '@/components/Subjects/ShortAnswer'
import MultipleChoices from '@/components/Subjects/MultipleChoices'
import Icon from 'vux/src/components/icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'

import XInput from 'vux/src/components/x-input/index'
import {fetch, promptMessage} from '@/api/dataHandling'
import {urlConfig} from '@/api/urlConfig'
import {getken} from '@/api/getToken'
import {getUrlParam} from '@/utils/urlUtil'

/**
*  字段说明：
*  examName 名称
*  examType 1在线考试，分值在每题上，是否正确  2 在线问卷 无分数、无测试结果 3 在线测试，分数在每个答案上，后台计算分值不一样
*  canAnwser 是否可以继续答题，后台控制
*  subjects 试题信息
*  personExams 答题信息
* personInfoId 个人基本信息id
*/
export default {
name: 'startExamNoPerson',
directives: {
TransferDom
},
components: {
XInput,
Choices,
Group,
Cell,
XHeader,
Grid,
GridItem,
Divider,
Card,
XButton,
XDialog,
Judgement,
Loading,
MultipleChoices,
FormPreview,
Icon,
ShortAnswer
},
data () {
return {
loadingShow: false,
show: false,
modules: {},
currentModule: {},
currentModuleIndex: 0,
queryParam: {
examinationId: undefined
},
examName: undefined,
attention: '',
personInfoId: '',
personExams: {},
canAnwser: '',
examType: '',
personInfo: {},
score: 0,
evalLevel: '',
eval: '',
suggest: '',
remark: '',
personModule: [],
username: '',
mobile: '',
personType: '',
consultUser: ''
}
},
created () {
this.loadingShow = true
const personType = getUrlParam('personType')
const consultUser = getUrlParam('consultUser')
window.localStorage.setItem('personType', personType)
window.localStorage.setItem('consultUser', consultUser)
getken(this.startExam) 
},
methods: {
startExam: function () {
this.personInfoId = 'NONE'
this.queryParam.examinationId = getUrlParam('id')
fetch('post', urlConfig.examSubjectGet, {
examinationId: this.queryParam.examinationId,
personInfoId: this.personInfoId
}).then(resp => {
this.personType = window.localStorage.getItem('personType')
this.consultUser = window.localStorage.getItem('consultUser')
const {examName, modules, personExams, canAnwser, examType, attention, remark} = resp
this.examName = examName
this.canAnwser = canAnwser
this.examType = examType
this.attention = attention
this.modules = modules
this.remark = remark
if (this.modules) {
this.currentModule = modules[0]
}
this.setPersonExams(personExams)
this.loadingShow = false
}).catch((e) => {

this.loadingShow = true
})
},
next: function () {
for (let i = 0; i < this.modules.length; i++) {
if (this.modules[i].id === this.currentModule.id) {
if (i === this.modules.length - 1) {
promptMessage('已经是最后一题了!')
break
}
this.currentModule = this.modules[++i]
this.currentModuleIndex = i
this.setScorll()
break
}
}
},
pre: function () {
for (let i = 0; i < this.modules.length; i++) {
if (this.modules[i].id === this.currentModule.id) {
if (i === 0) {
promptMessage('已经是第一题了!')
break
}
this.currentModule = this.modules[--i]
this.currentModuleIndex = i
break
}
}
},
setPersonExams (personExams) {
if (personExams.length > 0) {
this.personExams = personExams
const {score, evalLevel, suggest, modules} = personExams[personExams.length - 1]
this.score = score
this.evalLevel = evalLevel
this.eval = personExams[0].eval
this.suggest = suggest
this.personModule = modules
}
},
subCommit () {
this.$nextTick(() => {
this.loadingShow = true
let moduleJson = []
for (let i = 0; i < this.modules.length; i++) {
let moduleTemp = {}
moduleTemp.examinationModuleId = this.modules[i].id
for (let j = 0; j < this.modules[i].subjects.length; j++) {
let temp = {}
temp.subjectId = this.modules[i].subjects[j].subjectId
temp.anwser = this.modules[i].subjects[j].userAnswer
temp.userInput = JSON.stringify(this.modules[i].subjects[j].userInput)
if (!moduleTemp.anwsers) {
moduleTemp.anwsers = []
}
moduleTemp.anwsers.push(temp)
}
moduleJson.push(moduleTemp)
}
if (moduleJson) {
let personType = window.localStorage.getItem('personType')
let consultUser = window.localStorage.getItem('consultUser')
fetch('post', urlConfig.examSubjectSave, {consultUser: consultUser, personType: personType, userName: this.username, mobile: this.mobile, examType: this.examType, examinationId: this.queryParam.examinationId, personInfoId: this.personInfoId, modules: moduleJson})
.then(resp => {
this.canAnwser = 2
this.loadingShow = false
this.setPersonExams(resp.personExams)
}).catch(() => {
this.loadingShow = false
})
}
})
},
getPersonInfoId (openId) {
let hosCode = window.localStorage.getItem('hosCode')
axios.post(urlConfig.getWxBasicInfoByOpenId + '?openid=' + openId + '&hosCode=' + hosCode).then(res => {
let resultCode = res.data.resultCode

if (resultCode === 'error') {
this.toReg(hosCode)
} else {
this.personInfoId = openId
this.startExam() 
}
}).catch(error => {
console.log(error)
})
},
toReg (hosCode) {
window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3MDM0MzI2Mw==&scene=124#wechat_redirect'
},
getOpenId (code) {
let hosCode = window.localStorage.getItem('hosCode')
axios.get('http://front.cd.jinxin-fertility.com/weixin/getOpenIdByCode?code=' + code + '&hosCode=' + hosCode).then(response => {
const {data} = response
const {resultMsg, openid} = data
if (openid) {
window.localStorage.setItem('openid', openid)
this.getPersonInfoId(openid)
} else {
promptMessage(resultMsg)
}
})
},
getWechatCode () {
this.loadingShow = true
let _this = this
let hosCode = _this.$route.query.hosCode
window.localStorage.setItem('hosCode', hosCode)
const code = getUrlParam('code')
if (code) {
_this.getOpenId(code)
return
}
axios.get('http://front.cd.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href) + '&hosCode=' + hosCode).then(response => {
const {data} = response
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + data.appId + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
})
},
setScorll () {
this.$nextTick(() => {

window.scrollTo(0, 0)
})
}
}
}



// WEBPACK FOOTER //
// ./src/project/exam/startExamNoPerson.vue